/* eslint-disable react/display-name */
import * as React from 'react';

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.08">
    <path d="M15.49,0h0A.52.52,0,0,1,16,.54v0l-.31,3.17a.47.47,0,0,1-.21.36l0,0L11.05,7a3.78,3.78,0,0,0-1.59,3v5.58a.53.53,0,0,1-.1.32.51.51,0,0,1-.7.09h0L6.73,14.46a.47.47,0,0,1-.19-.37v-4a3.77,3.77,0,0,0-1.6-3l0,0L.54,4.19a.52.52,0,0,1-.23-.35v0L0,.56V.51A.51.51,0,0,1,.49,0h15ZM12.93,1.86H3.16a.41.41,0,0,0-.4.41v0l.12,1.12a.42.42,0,0,0,.21.31L6.24,5.5l0,0,1.13.72.28.18a.77.77,0,0,0,.8,0l.57-.37.87-.57L13,3.61a.46.46,0,0,0,.19-.3l.11-1A.39.39,0,0,0,13,1.87Z" />
  </svg>
);

export default FilterIcon;
